<template>
  <div class="archive-low_carbon_action">
    <div v-if="!isReady">
      <loader-svg></loader-svg>
    </div>

    <div class="container-fluid" v-if="isReady">
      <div class="row">
        <div class="col-12 col-md-12 col-lg-3 col-xl-2">

          <div style="height: 40px" class="d-flex justify-content-between align-items-center">
            <h5 style="border-bottom: 2px solid #ddd">Filtres</h5>
            <button
              @click.prevent="resetFilters()"
              class="btn btn-sm btn-outline-danger cursor cursor-pointer"
              v-show="isFilters"
            >
            &#215; Effacer les filtres
            </button>
          </div>

          <!-- <hr> -->

          <div id="filter_accordion">
            <div
              class="card mb-1"
              v-for="(filterData, filterDataIdx) in filterDataSctructure"
              :key="`filterData_${filterDataIdx}`"
            >
              <div
                class="card-header cursor cursor-pointer"
                :id="`heading_${filterDataIdx}`"
                data-toggle="collapse"
                :data-target="`#collapse_${filterDataIdx}`"
                aria-expanded="false"
                :aria-controls="`collapse_${filterDataIdx}`"
              >
                <!-- <h5 class="mb-0"> -->

                <div class="d-flex justify-content-between align-items-center">
                  <span class="btn- btn-link-">
                    {{ filterData.title }}
                  </span>
                  <span
                    class="badge badge-primary badge-pill"
                    v-if="filters[filterData.filterVar].length > 0"
                    >{{ filters[filterData.filterVar].length }}</span
                  >
                </div>
                <!-- </h5> -->
              </div>

              <div
                :id="`collapse_${filterDataIdx}`"
                class="collapse"
                :aria-labelledby="`heading_${filterDataIdx}`"
                data-parent="#filter_accordion"
              >
                <div class="filter-body">
                  <ul class="list-group list-group-flush">
                    <li
                      class="list-group-item"
                      v-for="filterItem in filterData.source"
                      :key="filterItem.id"
                    >
                      <label
                        ><input
                          type="checkbox"
                          v-model="filters[filterData.filterVar]"
                          :value="filterItem.id"
                        />
                        {{ filterItem.name }}
                      </label>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="col-12 col-md-12 col-lg-9 col-xl-10">
          <div style="height: 40px">
            {{ actionsFiltered.length }} action{{
              actionsFiltered.length > 1 ? "s" : ""
            }}
            trouvée{{ actionsFiltered.length > 1 ? "s" : "" }}
          </div>
          <div class="row">
            <div
              v-for="low_carbon_action in actionsFiltered"
              :key="low_carbon_action.id"
              class="col-12 col-sm-12 col-md-6 col-lg-4 col-xl-3 col-xl-3 cursor cursor-pointer"
              @click.prevent="goToUrl(low_carbon_action.link)"
            >
              <div class="card mb-4">
                <img
                  width="385"
                  height="220"
                  :src="getPostImage(low_carbon_action.id, 'action-thumbnail')"
                  class="wp-post-image"
                  alt=""
                  decoding="async"
                  style="aspect-ratio: 1 / 1; width: 100%; object-fit: cover"
                />

                <!-- {{ getCompagnyData(low_carbon_action.acf.structure_organisation[0]) }} -->
                <div class="d-flex justify-content-center">
                  <img
                    width="220"
                    height="110"
                    :src="
                      getCompagnyData(
                        low_carbon_action.acf.structure_organisation[0]
                      ).logo
                    "
                    class="logo-card wp-post-image"
                    alt=""
                    decoding="async"
                    loading="lazy"
                    style=""
                  />
                </div>
                <div class="card-body">
                  <h6
                    class="card-title"
                    v-html="
                      setTitleWithFormat(low_carbon_action.title.rendered)
                    "
                  ></h6>

                  <div class="debug" v-if="isDebug">
                    <hr />
                    id: {{ low_carbon_action.id }}

                    <dl>
                      <template
                        v-if="getAcfData(low_carbon_action.id).action_theme"
                      >
                        <dt>Thèmes:</dt>
                        <dd>
                          <ul>
                            <li
                              v-for="(term, termIdx) in getAcfData(
                                low_carbon_action.id
                              ).action_theme"
                              :key="`term_${termIdx}`"
                            >
                              {{ term?.name ? term.name : "--" }}
                            </li>
                          </ul>
                        </dd>
                      </template>
                      <template
                        v-if="getAcfData(low_carbon_action.id).action_scope"
                      >
                        <dt>Scopes:</dt>
                        <dd>
                          <ul>
                            <li
                              v-for="(term, termIdx) in getAcfData(
                                low_carbon_action.id
                              ).action_scope"
                              :key="`term_${termIdx}`"
                            >
                              {{ term?.name ? term.name : "--" }}
                            </li>
                          </ul>
                        </dd>
                      </template>
                      <template
                        v-if="
                          getAcfData(low_carbon_action.id).action_engagement
                        "
                      >
                        <dt>Engagements:</dt>
                        <dd>
                          <ul>
                            <li
                              v-for="(term, termIdx) in getAcfData(
                                low_carbon_action.id
                              ).action_engagement"
                              :key="`term_${termIdx}`"
                            >
                              {{ term?.name ? term.name : "--" }}
                            </li>
                          </ul>
                        </dd>
                      </template>
                    </dl>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import axios from "axios";
import Api from "@/api/index.js";
import LoaderSvg from "@/components/LoaderSvg.vue";
export default {
  name: "App",
  components: {
    LoaderSvg,
  },
  data() {
    return {
      isReady: false,
      isDebug: false,
      filters: {
        structure_type: [],
        compagnies: [],
        action_theme: [],
        action_scope: [],
        action_engagement: [],
      },
      apiData: {
        compagnies: [],
        structure_type: [],
        action_theme: [],
        action_scope: [],
        action_engagement: [],
        low_carbon_actions: [],
      },
    };
  },

  async created() {
    try {
      for (const [key] of Object.entries(this.apiData)) {
        let apiData = await this.callApi(key);
        this.apiData[key] = apiData;
      }

      this.isReady = true;
    } catch (error) {
      // console.log(error);
    }
  },
  computed: {
    filterDataSctructure() {
      return [
        {
          title: "Types de structure",
          source: this.structure_types,
          filterVar: "structure_type",
        },
        {
          title: "Structures",
          source: this.compagniesWithActions,
          filterVar: "compagnies",
        },
        {
          title: "Thématiques",
          source: this.action_theme,
          filterVar: "action_theme",
        },
        {
          title: "Scope d'action",
          source: this.action_scope,
          filterVar: "action_scope",
        },
        {
          title: "Engagement",
          source: this.action_engagement,
          filterVar: "action_engagement",
        },
      ];
    },
    action_theme() {
      return this.apiData.action_theme.filter((theme) => {
        return this.apiData.low_carbon_actions.find((compIdAction) =>
          compIdAction.action_theme.includes(theme.id)
        );
      });
    },
    action_scope() {
      return this.apiData.action_scope.filter((scope) => {
        return this.apiData.low_carbon_actions.find((compIdAction) =>
          compIdAction.action_scope.includes(scope.id)
        );
      });
    },
    action_engagement() {
      return this.apiData.action_engagement.filter((engagement) => {
        return this.apiData.low_carbon_actions.find((compIdAction) =>
          compIdAction.action_engagement.includes(engagement.id)
        );
      });
    },
    structure_types() {
      return this.apiData.structure_type.filter((compType) => {
        return this.compagniesIdWithActions.find(
          (compIdAction) => compType.id === compIdAction.typeId
        );
      });
    },
    compagniesIdWithActions() {
      let idList = [];
      this.apiData.low_carbon_actions.forEach((action) => {
        const structureOrganisationId = action.acf.structure_organisation[0];
        const structureOrganisationType = this.getCompagnyData(
          structureOrganisationId
        ).structure_type_id;
        if (!idList.includes(structureOrganisationId)) {
          idList.push({
            id: structureOrganisationId,
            typeId: structureOrganisationType,
          });
        }
      });

      return idList;
    },
    compagniesWithActions() {
      let compagnies = this.apiData.compagnies.filter((compagny) => {
        return this.compagniesIdWithActions.find(
          (compIdAction) => compagny.id === compIdAction.id
        );
      });

      let compagniesCustomData = [];
      compagnies.forEach((item) => {
        compagniesCustomData.push({ ...item, name: item.title.rendered });
      });

      return compagniesCustomData;
    },
    compagniesEnabled() {
      if (this.filters.structure_type.length === 0) {
        return this.compagniesWithActions;
      } else {
        return this.compagniesWithActions.filter((compWithAction) => {
          return this.filters.structure_type.includes(
            compWithAction.structure_type[0]
          );
        });
      }
    },
    actionsFiltered() {
      let actionsToShow = this.apiData.low_carbon_actions;

      actionsToShow = actionsToShow.filter((action) => {
        let isActionShowed = true;

        // Compagnies
        if (isActionShowed && this.filters.compagnies.length > 0) {
          const isCompagny = this.filters.compagnies.filter((x) =>
            action.acf.structure_organisation.includes(x)
          );
          isActionShowed = isCompagny.length > 0;
        }

        // Themes
        if (isActionShowed && this.filters.action_theme.length > 0) {
          const intersectTheme = this.filters.action_theme.filter((x) =>
            action.action_theme.includes(x)
          );
          isActionShowed = intersectTheme.length > 0;
        }

        // Scopes
        if (isActionShowed && this.filters.action_scope.length > 0) {
          const intersectScope = this.filters.action_scope.filter((x) =>
            action.action_scope.includes(x)
          );
          isActionShowed = intersectScope.length > 0;
        }

        // Engagements
        if (isActionShowed && this.filters.action_engagement.length > 0) {
          const intersectEngagement = this.filters.action_engagement.filter(
            (x) => action.action_engagement.includes(x)
          );
          isActionShowed = intersectEngagement.length > 0;
        }

        return isActionShowed;
      });

      // actionsToShow =  this.apiData.low_carbon_actions.filter(action => {
      //   return this.filters.compagnies.includes(action.acf.structure_organisation[0]);
      // })

      return actionsToShow;
    },
    isFilters() {
      let countFilter = 0;
      for (const [key] of Object.entries(this.filters)) {
        if (this.filters[key].length > 0) {
          countFilter++;
        }
      }

      return countFilter > 0;
    },
  },
  methods: {
    async callApi(apiType) {
      try {
        const results = await Api[apiType].get({
          filter: "_embed&per_page=100",
        });
        return results.data;
      } catch (error) {
        // console.log(error);
      }
    },
    setTitleWithFormat(title) {
      return title.length > 100 ? title.substr(0, 100) + "[...]" : title;
    },
    resetFilters() {
      for (const [key] of Object.entries(this.filters)) {
        this.filters[key] = [];
      }
    },
    isCompagnyEnable(compId) {
      const test = this.compagniesEnabled.find((compEnabled) => {
        return compEnabled.id === compId;
      });
      const result = test ? true : false;
      return result;
    },
    goToUrl(url) {
      window.location.href = url;
    },
    getPostImage(postId, size = "thumbnail") {
      const post = this.apiData.low_carbon_actions.find(
        (post) => post.id === postId
      );
      return post._embedded["wp:featuredmedia"][0].media_details.sizes[size]
        .source_url;
    },
    getCompagnyData(compagnyId) {
      const compagny = this.apiData.compagnies.find(
        (compagny) => compagny.id === compagnyId
      );
      return {
        title: compagny.title.rendered,
        logo: compagny._embedded["wp:featuredmedia"][0].media_details.sizes[
          "structure-thumbnail"
        ].source_url,
        link: compagny.link,
        structure_type_id:
          compagny.structure_type.length > 0
            ? compagny.structure_type[0]
            : null,
        structure_type_name:
          compagny._embedded["wp:term"] &&
          compagny._embedded["wp:term"].length > 0 &&
          compagny._embedded["wp:term"][0].length > 0
            ? compagny._embedded["wp:term"][0][0].name
            : "none",
      };
    },
    getAcfData(actionId) {
      let results = {};
      const fieldList = ["action_theme", "action_scope", "action_engagement"];
      const action = this.apiData.low_carbon_actions.find(
        (action) => action.id === actionId
      );

      fieldList.forEach((field) => {
        const fieldDataArray = action.acf[field];
        if (!results[field]) results[field] = [];
        if (fieldDataArray) {
          fieldDataArray.forEach((itemId) => {
            results[field].push({
              id: itemId,
              name: this.apiData[field].find((truc) => truc.id === itemId).name,
            });
          });
        } else {
          results[field] = null;
        }
      });

      return results;
    },
  },
  watch: {
    "filters.structure_type": {
      handler() {
        this.filters.compagnies = [];
      },
      deep: true,
    },
  },
};
</script>
